import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import Eshops from '@/sections/Eshops';
import Hero from '@/sections/Hero';
import MoreInfo from '@/sections/card/MoreInfo';
import { type IntlProps, getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation, Trans } from 'react-i18next';
import About from '@/sections/card/About';
import Benefits from '@/sections/card/Benefits';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { FaqIntro } from '@/sections/FaqIntro';
import { getPageBannerWithPromoSourceBySlug, PageBanner } from '@/api/sanity/pageBanners';
import React from 'react';
import usePromoSource from '@/hooks/usePromoSource';
import { SeoHeader } from '@/components/SeoHeader';
import { EshopsList, getAffiliateEshopsList } from '@/api/sanity/affiliateEshopsList';
import { useClientOnly } from '@/hooks/useClientOnly';
import { Link } from '@/components/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { useProductRegistrationButtons, useProductRegistrationLink } from '@/hooks/useProductRegistrationLink';
interface Props extends IntlProps {
  eshops: EshopsList;
  pageBanners: PageBanner[] | null;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(props) {
  const $ = _c(57);
  usePageView("card");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["card", "eshops"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const promoSource = usePromoSource();
  const {
    isClient
  } = useClientOnly();
  const {
    eshops,
    pageBanners,
    menuPromoBanners
  } = props;
  const registrationLink = useProductRegistrationLink("karta");
  let t1;
  if ($[1] !== isClient || $[2] !== pageBanners || $[3] !== promoSource) {
    t1 = isClient && promoSource && pageBanners?.find(banner_0 => banner_0.promoSource === promoSource) || pageBanners?.find(_temp);
    $[1] = isClient;
    $[2] = pageBanners;
    $[3] = promoSource;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const pageBanner = t1;
  const heroButtons = useProductRegistrationButtons(pageBanner?.buttons, "karta");
  let t2;
  if ($[5] !== t) {
    t2 = t("card:seo.title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("card:seo.description");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = pageBanner?.videoId;
  let t6;
  if ($[12] !== pageBanner?.title || $[13] !== t) {
    t6 = pageBanner?.title ?? t("card:heroSection.title");
    $[12] = pageBanner?.title;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== pageBanner?.text || $[16] !== t) {
    t7 = pageBanner?.text ?? t("card:heroSection.paragraph");
    $[15] = pageBanner?.text;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== heroButtons || $[19] !== registrationLink || $[20] !== t) {
    t8 = heroButtons ?? [{
      ariaLabel: t("card:heroSection.buttonPrimary"),
      label: t("card:heroSection.buttonPrimary"),
      to: registrationLink,
      testId: "cardHeroPrimaryCTA",
      analyticsParam: "cardHeroPrimaryCTA",
      variant: "primary"
    }];
    $[18] = heroButtons;
    $[19] = registrationLink;
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = pageBanner?.image?.url ?? "/images/sections/card/hero/cs/hero.png";
  let t10;
  if ($[22] !== pageBanner?.image?.alt || $[23] !== t) {
    t10 = pageBanner?.image?.alt ?? t("card:heroSection.title");
    $[22] = pageBanner?.image?.alt;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = {
      url: t9,
      alt: t10
    };
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const t12 = pageBanner?.variant || "mockupMobile";
  let t13;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
    t13 = <Hero videoId={t5} title={t6} text={t7} buttons={t8} image={t11} variant={t12} />;
    $[28] = t11;
    $[29] = t12;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="bg-blue-50"><SectionDelimiter color="bg-blue-100" background="bg-transparent" /></div>;
    t15 = <About />;
    t16 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    t17 = <Benefits />;
    t18 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t14 = $[35];
    t15 = $[36];
    t16 = $[37];
    t17 = $[38];
    t18 = $[39];
  }
  let t19;
  if ($[40] !== eshops) {
    t19 = eshops.length > 0 && <Eshops className="bg-blue-100 py-14 lg:py-20" eshops={eshops} />;
    $[40] = eshops;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Link to="/caste-dotazy/karta" analyticsParam="faqCard" testId="faqCard" />;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t) {
    t21 = <FaqIntro text={<Trans i18nKey="faqSection.text" t={t}>{t20}</Trans>} className="pt-10 pb-14 lg:pt-28 lg:pb-20" />;
    $[43] = t;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <MoreInfo />;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t19 || $[47] !== t21) {
    t23 = <div className="relative z-10">{t19}{t21}{t22}</div>;
    $[46] = t19;
    $[47] = t21;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t23) {
    t25 = <div className="relative overflow-hidden bg-blue-100">{t23}{t24}</div>;
    $[50] = t23;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== menuPromoBanners || $[53] !== t13 || $[54] !== t25 || $[55] !== t4) {
    t26 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t13}{t14}{t15}{t16}{t17}{t18}{t25}</Layout>;
    $[52] = menuPromoBanners;
    $[53] = t13;
    $[54] = t25;
    $[55] = t4;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  return t26;
}
function _temp(banner) {
  return !banner.promoSource;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('karta');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      pageBanners: await getPageBannerWithPromoSourceBySlug('card'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      eshops: await getAffiliateEshopsList('card'),
      ...(await getIntlProps(ctx, ['card', 'eshops']))
    }
  };
}) satisfies GetStaticProps<Props>;